var _rect, _path, _path2, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 5,
    fill: "#F89C1C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0257 33.2501H18.2332C15.6549 33.2501 14.0116 30.4876 15.2582 28.2209L18.5591 22.2142L21.6474 16.59C22.9366 14.2525 26.3082 14.2525 27.5974 16.59L30.6999 22.2142L32.1874 24.92L34.0007 28.2209C35.2474 30.4876 33.6041 33.2501 31.0257 33.2501Z",
    fill: "url(#paint0_linear_1403_2467)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.1667 33.9583C43.1667 39.0442 39.0442 43.1667 33.9583 43.1667C28.8725 43.1667 24.75 39.0442 24.75 33.9583C24.75 33.7175 24.7642 33.4908 24.7783 33.25H31.0258C33.6042 33.25 35.2475 30.4875 34.0008 28.2209L32.1875 24.92C32.7542 24.8067 33.3492 24.75 33.9583 24.75C39.0442 24.75 43.1667 28.8725 43.1667 33.9583Z",
    fill: "url(#paint1_linear_1403_2467)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 57.5,
    height: 57.5,
    rx: 4.75,
    stroke: "#2A85FF",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1403_2467",
    x1: 19.8168,
    y1: 17.7388,
    x2: 42.9905,
    y2: 31.9714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1403_2467",
    x1: 29.4347,
    y1: 27.6524,
    x2: 51.9368,
    y2: 40.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignSystem);
export default __webpack_public_path__ + "static/media/design-system.4f4532b459314239aac8e2615ed294c1.svg";
export { ForwardRef as ReactComponent };